<template>
  <div class="service">
    <v-form>
      <v-row>
        <v-col cols="12">
          <v-btn depressed color="primary" :disabled="!canEditService" @click="editService(null)"
            >New Service</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="services"
            dense
            class="searchResults"
            @click:row="editService"
            item-key="ServiceId"
            :items-per-page="-1"
            :loading="loading"
            loading-text="Loading services..."
            :single-select="true"
            :calculate-widths="true"
          >
            <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item, value }">
              {{ formatTableEl(item, value, header.format) }}
            </template>
          </v-data-table>

          <Sidebar
            :isShown="isSidebarShown"
            :isNew="isNew"
            :formElements="formElements"
            :sidebarName="sidebarName"
            :isFormValid="isFormValid"
            :actionsDisabled="!canEditService"
            @form-validity="isFormValid = $event"
            @delete="onDelete"
            @cancel="cancelChanges"
            @save="saveChanges"
          >
          </Sidebar>
        </v-col>
      </v-row>
    </v-form>
    <Dialog ref="confirmationDialog"></Dialog>
  </div>
</template>

<script>
import Sidebar from '@/components/layout/Sidebar.vue';
import Dialog from '@/components/layout/Dialog.vue';
import Utils from '@/utils.js';

export default {
  components: { Sidebar, Dialog },
  name: 'Search',

  data() {
    return {
      loading: false,
      isSidebarShown: false,
      sidebarName: "service",
      formElements: [],
      allElements: [],
      headers: [],
      services: [],
      selectedService: null,
      isFormValid: false,
    };
  },

  computed: {
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    isNew() {
      if (this.selectedService) return false;
      return true;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    canEditService() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    memberId() {
      this.getServices();
    },
  },

  created() {
    this.getHeaders();
  },

  mounted: function () {
    if (!this.memberId) {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    } else {
      this.getForm('Service');
      this.$root.currentPage = 'Service';
    }
  },

  methods: {
    displayDate(date) {
      if (date.getFullYear() <= 1900) return null;
      return Utils.getDateStr(date);
    },
    editService(item) {
      if (!item && !this.canEditService) return;
      this.isSidebarShown = true;
      if (item) {
        this.getServiceById(item.ServiceId);
      } else {
        this.formElements.forEach((el) => (el.Value = ''));
        this.selectedService = null;
      }
    },
    cancelChanges() {
      this.isSidebarShown = false;
      this.selectedService = null;
    },
    saveChanges() {
      if (this.isFormValid) {
        this.isSidebarShown = false;
        if (this.isNew) {
          this.addService();
        } else {
          this.updateService();
        }
      }
    },
    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.isSidebarShown = false;
        this.deleteService();
      } catch (err) {
        console.log();
      }
    },
    
    formatTableEl(item, value, format) {
      return Utils.formatTableValue(value, format);
    },
    async addService() {
      const newService = {};
      this.allElements.forEach((el) => {
        newService[el.FieldName] = el.Value;
      });
      this.formElements.forEach((el) => {
        newService[el.FieldName] = el.Value;
      });
      newService.MembershipID = this.memberId;
      try {
        await this.$api.post('/Service/UpdateService', newService);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Service was added',
        });
        this.getServices();
      } catch (err) {
        console.log(err.message);
      }
    },
    async updateService() {
      this.loading = true;
      try {
        this.formElements.forEach((el) => {
          this.selectedService[el.FieldName] = el.Value;
        });

        await this.$api.post('/Service/UpdateService', this.selectedService);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Service was updated',
        });
        this.getServices();
      } catch (err) {
        console.log(err.message);
      }
    },
    async deleteService() {
      this.loading = true;
      try {
        await this.$api.delete('/Service/DeleteService?Id=' + this.selectedService.ServiceId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Service was deleted',
        });
        this.getServices();
      } catch (err) {
        console.log(err.message);
      }
    },
    async getServices() {
      this.loading = true;
      try {
        let response = await this.$api.get(
          '/Service/GetServiceList?membershipid=' + this.memberId + '&orderBy=ServiceType'
        );
        this.services = response.data;
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },
    async getServiceById(id) {
      try {
        let response = await this.$api.get('/Service/GetService?Id=' + id);

        if (!response.data) {
          const msg = 'Unable to load service with id ' + id;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.selectedService = response.data;
        var data = response.data;
        // match data with form fields
        if (data) Utils.setDataToFormElements(data, this.formElements);
      } catch (err) {
        console.error(err);
      }
    },
    async getForm(formName) {
      try {
        let response = await this.$api.get(
          `/datadictionary/GetFormElements?formName=${formName}&planId=${this.currentPlanId}`
        );
        this.allElements = response.data;
        if (response.data.length)
          this.formElements = response.data.filter((f) => f.Visible == true);
        this.getServices();
      } catch (err) {
        console.error(err);
      }
    },
    async getHeaders() {
      try {
        const response = await this.$api.get(
          `/datadictionary/GetGridHeaders?formName=Service&planId=${this.currentPlanId}`
        );
        if (response.data.length) {
          const data = response.data.filter((item) => item.Visible);
          data.sort((a, b) => a.ColumbOrder - b.ColumbOrder);
          this.headers = data.map((item) => ({
            text: item.HeaderText,
            value: item.Datafield,
            align: item.Align.toLowerCase(),
            format: item.FieldFormat,
          }));
        }
      } catch (err) {
        console.log(err.message);
      }
    },
  },
};
</script>

<style scoped>
.service {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;
}

.sidebar {
  margin-bottom: 30px;
}

.sidebar h3 {
  margin-bottom: 20px;
}

.btnsContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.btnsContainer > div {
  display: inline-block;
}
</style>
